/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DDayLayers, Layers} from "../view/DDayLayers";
import {DDay} from "../DDay";
import {Translation} from "../../core/utils/Translation";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {TimelineLite} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Impact} from "../Font/Impact";
import {BlitzKriegGameMode} from "../server/BlitzKriegGameMode";
import {GameHelper} from "../../core/utils/GameHelper";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";
import {IWinRatioConfig} from "../../core/config/WinRatio";
import {DDayGameConfig} from "../DDayGameConfig";

export class FreespinOutro extends ContinueScreen {

    private _spinName: PIXI.Sprite;
    private _youWin: PIXI.Text;
    private _wonAmount: PIXI.Text;
    private _texture: PIXI.spine.Spine;
    private _backgroundGFX: PIXI.Graphics;

    constructor() {
        super(DDayLayers.getLayer(Layers.SCREENS)!);
        this._backgroundGFX = new PIXI.Graphics();
        this._backgroundGFX.visible = false;
        this._youWin = new PIXI.Text("", new PIXI.TextStyle({
            fontFamily: Impact.FAMILY,
            fontSize: "80px",
            stroke: "#000000",
            strokeThickness: 10,
            fill: "#EFEBDE",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowAlpha: 0.7,
            dropShadowAngle: 90,
            dropShadowDistance: 10,
            lineJoin: "round"
        }));
        this._wonAmount = new PIXI.Text("", new PIXI.TextStyle({
            fontFamily: Impact.FAMILY,
            fontSize: "80px",
            stroke: "#000000",
            strokeThickness: 10,
            fill: "#EFEBDE",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowAlpha: 0.7,
            dropShadowAngle: 90,
            dropShadowDistance: 10,
            lineJoin: "round"
        }));

        this._texture = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("fsOutro"));
        this._texture.visible = false;
        this._texture.position.set(360, 360);

        this._youWin.anchor.set(0.5, 0.5);
        this._youWin.position.set(360, 380);

        this._wonAmount.anchor.set(0.5, 0.5);
        this._wonAmount.position.set(360, 480);

        this._spinName = new PIXI.Sprite(DDay.assetLoader.getTextures("outro_neptune")[0]);
        this._spinName.anchor.set(0.5, 0.5);
        this._spinName.position.set(360, 175);
        this._spinName.visible = false;

        this.setOverlayProps();
        this._container.addChild(this._backgroundGFX, this._texture, this._spinName, this._youWin, this._wonAmount);
    }

    protected setOverlayProps(): void {
        if (this._backgroundGFX) {
            const bounds: ScreenBounds = NolimitApplication.screenBounds;
            this._backgroundGFX.clear();
            this._backgroundGFX.beginFill(0x000000, 0.7);
            this._backgroundGFX.drawRect(bounds.left - 600, bounds.top - 300, 3 * bounds.width, 3 * bounds.height);
            this._backgroundGFX.endFill();
        }
    }

    public show(onContinueCallBack: () => void) {
        const belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowStake();
        SlotGame.keypadPlugin.setWin(DDay.model.parsedGameData.totalWin, true, belowStakeWinRestriction);
        SlotGame.keypadPlugin.hide();

        let isToggeled: boolean = false;
        if (GameHelper.isBoostedBetAllowed()) {
            isToggeled = DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET";
        }
        BlitzKriegSound.fadeAndStopSound({name: BlitzKriegSound.FREESPIN_MUSIC, to: 0, duration: 50});
        BlitzKriegSound.switchMusic({name: BlitzKriegSound.MAIN_GAME_MUSIC});
        if (!belowStakeWinRestriction) {
            BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_END});
            BlitzKriegSound.playTrack({name: "mainXbet", volume: isToggeled ? 1 : 0});
            //TODO: DO NOT play sound and count up, show end number directly.
        }
        this._backgroundGFX.visible = true;
        this._texture.visible = true;
        this._texture.state.setAnimation(0, "FS_outro", true).timeScale = 0.3;
        this._spinName.texture = DDay.assetLoader.getTextures(DDay.commonService.getFSOrSFSName())[0];
        this._spinName.visible = true;
        const winNumber = SlotGame.apiPlugin.currency.formatValue(DDay.model.parsedGameData.totalWin);
        this._youWin.visible = (!BelowStakeWinRestriction.isWinBelowStake() && (DDay.model.parsedGameData.totalWin > 0));
        this._youWin.text = `${belowStakeWinRestriction ? "" : Translation.translation("You won")}`;
        this._wonAmount.text = `${winNumber}`
        const spinPlayed = DDay.model.parsedGameData.numberOfFreespinsPlayed;
        super.show(onContinueCallBack);
        if (!BelowStakeWinRestriction.isWinBelowStake()) {
            let belowBetWinLevel: boolean = DDay.model.data.accumulatedRoundWin < BelowStakeWinRestriction.getBuyFeaturePrice();
            let equalBetWinLevel: boolean = DDay.model.data.accumulatedRoundWin === BelowStakeWinRestriction.getBuyFeaturePrice();
            if (belowBetWinLevel) {
                BlitzKriegSound.playTrack({name: BlitzKriegSound.TINY_WIN});
            } else if (equalBetWinLevel) {
                BlitzKriegSound.playTrack({name: BlitzKriegSound.SMALL_WIN});
            } else {
                let level: IWinRatioConfig | undefined = this.getRatio(DDay.model.parsedGameData.totalWin / DDay.model.parsedGameData.playedBetValue);
                if (level && level?.ratio > 5) {
                    BlitzKriegSound.playTrack({name: BlitzKriegSound.LARGE_WIN});
                } else {
                    BlitzKriegSound.playTrack({name: BlitzKriegSound.MEDIUM_WIN});
                }
            }
        }
        super.enableContinueButton();
    }

    private getRatio(winRatio: number): IWinRatioConfig | undefined {
        let ratioConfigs: IWinRatioConfig[] = DDayGameConfig.WIN_RATIOS;

        let ratioConfig;
        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }
        return ratioConfig;
    }

    protected close(): TimelineLite {
        const tl = new TimelineLite();
        DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL);
        if (!BelowStakeWinRestriction.isWinBelowStake()) {
            BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_END_OUTRO});
        }
        if (GameHelper.isBoostedBetAllowed()) {
            if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET") {
                DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, true);
            }
        }
        tl.add(super.close());
        tl.add(() => {

            this._backgroundGFX.visible = false;
            this._texture.visible = false;
            GameHelper.resetSpine(this._texture);
            this._spinName.visible = false;
            BelowStakeWinRestriction.reset();
        }); // TODO: if there is win cap, remember to do the same reset.

        return tl;
    }
}
